import { useUser } from "contexts/userContext/userContext";

const useSuspendedUser = () => {
  const { getUserData } = useUser();

  const isUserSuspended = getUserData()?.IsSuspended;

  return { isUserSuspended };
};

export default useSuspendedUser;
